module.exports = __webpack_public_path__ + "img/sq4m_01.42807670.jpg";